import React from 'react';

import { FieldPathId, FieldPathList } from '@rjsf/utils';

import { Box, Typography } from '@mui/material';

import AddableCheckboxGroup from './AddableCheckboxGroup';

interface AmenitiesProps {
  onChange: (value: Array<string> | undefined, path: FieldPathList) => void;
  formData: Array<string>;
  fieldPathId: FieldPathId;
  registry: {
    formContext: {
      amenityOptions: Array<string>;
      amenitiesHelperText?: string;
      onStartAddingAmenities: () => void;
      onSyncRoomAmenities?: () => void;
      isGeneratingRoomAmenities?: boolean;
      isFlashOffer?: boolean;
    };
  };
}

function Amenities({ onChange, formData, fieldPathId, registry }: AmenitiesProps) {
  const { formContext } = registry;
  const options = formContext.amenityOptions;

  const handleChange = (value: string, checked: boolean) => {
    const currentSelection = formData || [];

    let nextSelection: Array<string>;

    if (checked) {
      nextSelection = [...currentSelection, value];
    } else {
      nextSelection = currentSelection.filter((option) => option !== value);
    }

    onChange(nextSelection, fieldPathId.path);
  };

  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{
          textTransform: 'uppercase',
          color: 'text.secondary',
          mb: 2,
        }}
      >
        Amenities
      </Typography>
      {formContext.amenitiesHelperText && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {formContext.amenitiesHelperText}
        </Typography>
      )}
      <AddableCheckboxGroup
        options={options}
        selection={formData || []}
        onChange={handleChange}
        onStartAddingAmenities={formContext.onStartAddingAmenities}
        onSyncRoomAmenities={formContext.onSyncRoomAmenities}
        isGeneratingRoomAmenities={formContext.isGeneratingRoomAmenities}
        isFlashOffer={formContext.isFlashOffer}
      />
    </Box>
  );
}

export default Amenities;
